import { render, staticRenderFns } from "./ServicePartnerStatusChange.vue?vue&type=template&id=321a872c&scoped=true"
import script from "./ServicePartnerStatusChange.vue?vue&type=script&lang=js"
export * from "./ServicePartnerStatusChange.vue?vue&type=script&lang=js"
import style0 from "./ServicePartnerStatusChange.vue?vue&type=style&index=0&id=321a872c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a872c",
  null
  
)

export default component.exports